/**
 * @changelog
 *
 * 2026-10-22 (0.1.0) (jhoward)
 *   - Move tierPointThresholds out of Accountinfo.d.ts: a .d.ts holds only types, so Vite could not load the value import.
 */

export const tierPointThresholds = [
  { name: 'red', threshold: 0 },
  { name: 'bronze', threshold: 500 },
  { name: 'gold', threshold: 2000 },
  { name: 'platinum', threshold: 7500 },
  { name: 'diamond', threshold: 30000 },
];
